"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_array_like_1 = require("./is-array-like");
exports.default = (function (value) {
    return is_array_like_1.default(value) ? Array.prototype.slice.call(value) : [];
});
//# sourceMappingURL=to-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/to-array.js
// module id = 1152
// module chunks = 37